export enum UserRole {
  SUPER_ADMIN = 1,
  ADMIN = 2,
  USER = 3,
}

export interface User {
  created_at: string;
  updated_at: string;
  id: string;
  address: string;
  role: UserRole;
  first_name?: string;
  last_name?: string;
  email?: string;
  rain_user_id?: string;
  is_kyc?: boolean;
  rain_verification_url?: string;
  rain_signature?: string;
  referral_code?: string;
}

export interface GetUsersParams {
  page?: number;
  limit?: number;
  search?: string;
  role?: UserRole | "";
}
